import React from 'react';
import cn from 'classnames';

export default function Input({
  type = 'text',
  label,
  value,
  placeholder = '',
  onChange,
  variant = 'default',
  ...props
}) {
  const className = cn('input-wrap', {
    'input-type-search': type === 'search',
    [`input-${variant}`]: variant,
    'input-filled': !!value,
    'input-empty': !value
  })

  const handleChange = ({ target }) => {
    onChange(target.value);
  }

  return (
    <div className={className}>
      <label>
        {type !== 'search' && label}
        <input type={type} placeholder={placeholder} value={value} onChange={handleChange} {...props} />
      </label>
    </div>
  )
}
